import useToggle from '@/shared/hooks/useVisible';
import { commonQueries, usePersistStore } from '@/shared/lib/store';
import { useModalStore } from '@/shared/lib/store/model/modal.store';
import { VivaModalForm } from '@/shared/ui';
import { schoolMap } from '@/shared/utils/publish';
import { useEffect, useState } from 'react';

const apiKey = import.meta.env.VITE_X_VIVASAM_API_KEY;

export const PublishOptionStep2Class = ({
    selectClass,
    setSelectClass,
    classMemberList,
    setClassMemberList,
    checkCurriBookList,
    tags,
    setTags,
    onClose,
    checkList,
}: {
    selectClass?:
        | API.MyClassMemberList.ClassData
        | { classInfo: { classSeq: number; clsName: string } };
    setSelectClass: React.Dispatch<
        React.SetStateAction<
            | API.MyClassMemberList.ClassData
            | {
                  classInfo: {
                      classSeq: number;
                      clsName: string;
                  };
              }
            | undefined
        >
    >;

    classMemberList: API.MyClassMemberList.ClassData[];
    setClassMemberList: React.Dispatch<React.SetStateAction<API.MyClassMemberList.ClassData[]>>;
    checkCurriBookList: string[];
    tags: DATA.TagItem[];
    setTags: React.Dispatch<React.SetStateAction<DATA.TagItem[]>>;
    onClose: () => void;
    checkList: DATA.Exam[];
}) => {
    const { showModal, closeModal } = useModalStore();
    const { sMyClassMemberList } = usePersistStore();
    const [selectClassOpen, setSelectClassOpen] = useToggle();
    const [trigger, setTrigger] = useState(0);
    const [checkSubjectList, setCheckSubjectList] = useState<API.GetCodeToClass.ListItem[]>([]);

    // 특정 반이 "모두 체크" 상태인지 확인
    const isClassAllSelected = classMemberList
        .find((classItem) => classItem.classInfo.classSeq === selectClass?.classInfo.classSeq)
        ?.checkStudents?.every((s) => s.checked);

    const isClassSelected = (memberId: string) =>
        classMemberList
            .find((classItem) => classItem.classInfo.classSeq === selectClass?.classInfo.classSeq)
            ?.checkStudents?.find((stnt) => stnt.memberId === memberId)?.checked;

    const containsValue = (array: any[], key: string, value: string) => {
        return array.some((item) => item[key] === value);
    };

    const { data: getCodeToClassData, isLoading } = commonQueries.getCodeToClass(
        checkList[0].curriBookCd,
        !!checkList[0].curriBookCd
    );

    useEffect(() => {
        if (getCodeToClassData?.status === 200 && getCodeToClassData?.data?.list) {
            setCheckSubjectList(getCodeToClassData?.data?.list);
        }
    }, [getCodeToClassData]);

    useEffect(() => {
        trigger !== 0 && handleComplete();
    }, [trigger]);

    useEffect(() => {
        return setSelectClass(undefined);
    }, []);

    useEffect(() => {
        if (selectClass && selectClass?.classInfo.classSeq === -999) {
            handleAllComplete();
        }
    }, [selectClass]);

    const handleComplete = () => {
        const newTags: DATA.TagItem[] = [];
        const found = classMemberList.find(
            (v) => v.classInfo.classSeq === selectClass?.classInfo.classSeq
        );
        if (!found) return;
        const claIdString = String(
            'viva-' +
                found.classInfo.schCode +
                '-' +
                found.classInfo.crtYear +
                '-' +
                found.classInfo.schYear +
                '-' +
                found.classInfo.classSeq +
                '-' +
                (checkCurriBookList && checkCurriBookList[0])
        );
        const existingTagIndex = tags.findIndex((t) => t.claId === claIdString);
        const selectedStudents = found?.checkStudents.filter((s) => s.checked);
        if (existingTagIndex >= 0) {
            setTags((prev) => {
                const copy = [...prev];

                const existingTag = { ...copy[existingTagIndex] };
                (existingTag.stdtUserInfo = selectedStudents.map((s) => ({
                    stdtUserId:
                        s.memberId.split('M')[0] +
                        '-' +
                        found.classInfo.classSeq +
                        '-' +
                        (checkCurriBookList ? checkCurriBookList[0] : ''),
                    nickNm: '',
                }))),
                    (copy[existingTagIndex] = existingTag);
                return copy;
            });
        } else {
            newTags.push({
                claId: claIdString,
                schlCd: found.classInfo.schCode,
                schlNm: found.classInfo.schName,
                year: found.classInfo.crtYear,
                claNm: found.classInfo.clsName,
                gradeCd: found.classInfo.schYear,
                stdtUserInfo: selectedStudents.map((s) => ({
                    stdtUserId:
                        s.memberId.split('M')[0] +
                        '-' +
                        found.classInfo.classSeq +
                        '-' +
                        (checkCurriBookList ? checkCurriBookList[0] : ''),
                    nickNm: '',
                })),
            });
            setTags((prev) => [...prev, ...newTags]);
        }
    };
    const filterStntList = () => {
        const found = classMemberList?.find(
            (e) => e.classInfo.classSeq === selectClass?.classInfo.classSeq
        );
        return found?.memberInfo;
    };
    const propsFilterStntList = (classSeq: number) => {
        const found = classMemberList?.find((e) => e.classInfo.classSeq === classSeq);
        return found?.memberInfo;
    };

    // 개별 리스트 전체 선택/해제 핸들러
    const handleClassSelectAll = (classSeq: number, isChecked: boolean) => {
        const checkSubject = checkSubjectList.map((item) => item.labSubject);

        setClassMemberList((prev: API.MyClassMemberList.ClassData[]) =>
            prev?.map((classItem) => {
                return classItem.classInfo.classSeq === classSeq
                    ? {
                          ...classItem,
                          checkStudents: classItem.checkStudents?.map((student) => ({
                              ...student,
                              checked:
                                  classItem.classInfo.clsTypeCode === '2'
                                      ? checkSubject.includes(
                                            classItem.classInfo.schSubject
                                                ? classItem.classInfo.schSubject
                                                : classItem.classInfo.schCourse
                                        )
                                          ? isChecked
                                          : false
                                      : isChecked,
                          })),
                      }
                    : classItem;
            })
        );
    };

    // 전체 리스트 전체 선택/해제 핸들러
    const handleGlobalSelectAll = () => {
        setClassMemberList((prev) =>
            prev?.map((classItem) => ({
                ...classItem,
                checkStudents: classItem.checkStudents?.map((student) => ({
                    ...student,
                    checked: true,
                })),
            }))
        );
    };

    const handleAllComplete = () => {
        const newTags: DATA.TagItem[] = [];
        const filteredClassMemberList = classMemberList?.filter((classItem) => {
            const check = checkList?.[0];
            if (!check || isLoading) return false;

            const { clsTypeCode, schTypeCode, schYear, schSubject, schCourse } =
                classItem.classInfo;
            const disabled = disabledClass(
                clsTypeCode,
                schSubject,
                schCourse,
                schTypeCode,
                schYear
            );

            return !disabled;
        });

        filteredClassMemberList?.forEach((classItem) => {
            const selectedStudents = classItem.memberInfo;
            const claIdString = String(
                'viva-' +
                    classItem.classInfo.schCode +
                    '-' +
                    classItem.classInfo.crtYear +
                    '-' +
                    classItem.classInfo.schYear +
                    '-' +
                    classItem.classInfo.classSeq +
                    '-' +
                    (checkCurriBookList && checkCurriBookList[0])
            );
            newTags.push({
                claId: claIdString,
                schlCd: classItem.classInfo.schCode,
                schlNm: classItem.classInfo.schName,
                year: classItem.classInfo.crtYear,
                claNm: classItem.classInfo.clsName,
                gradeCd: classItem.classInfo.schYear,
                stdtUserInfo: selectedStudents.map((s) => ({
                    stdtUserId:
                        s.orgMemberId.split('M')[0] +
                        '-' +
                        classItem.classInfo.classSeq +
                        '-' +
                        (checkCurriBookList && checkCurriBookList[0]),
                    nickNm: '',
                })),
            });
        });

        handleGlobalSelectAll();
        setTags(newTags);
    };

    // 개별 학생 선택 핸들러
    const handleIndividualSelect = (classSeq: number, memberId: string, isChecked: boolean) => {
        setClassMemberList((prev) =>
            prev?.map((classItem) => {
                if (classItem.classInfo.classSeq === classSeq) {
                    return {
                        ...classItem,
                        checkStudents: classItem.checkStudents?.map((student) =>
                            student.memberId === memberId
                                ? { ...student, checked: isChecked }
                                : student
                        ),
                        memberInfo: classItem.memberInfo?.map((member) =>
                            member.orgMemberId === memberId
                                ? { ...member, checked: isChecked }
                                : member
                        ),
                    };
                } else {
                    return classItem;
                }
            })
        );
    };

    const disabledClass = (
        clsTypeCode?: string,
        schSubject?: string,
        schCourse?: string,
        schTypeCode?: string,
        schYear?: string
    ) => {
        const check = checkList?.[0];
        if (!check) return true;
        if (clsTypeCode === '') return false;

        const sameSchool = schoolMap[schTypeCode ?? ''] === check.curriSchoolVal;

        const sameGrade =
            clsTypeCode === '5'
                ? true
                : (schYear ?? '') === (check.curriGradeVal ?? '').replace(/\s?학년$/, '');

        const noneGrade = check.curriGradeVal === '학년 정보 없음';

        const isHomeroomLike =
            !clsTypeCode || clsTypeCode === '5' || (clsTypeCode === '1' && schTypeCode === 'ES');

        const checkSubject = checkSubjectList.map((item) => item.labSubject);

        const isSubjectClass = schSubject
            ? clsTypeCode === '2' && checkSubject.includes(schSubject ?? '')
            : clsTypeCode === '2' && checkSubject.includes(schCourse ?? '');

        const selectable =
            (isHomeroomLike || isSubjectClass) && sameSchool && (sameGrade || noneGrade);

        // 비활성 여부 반환
        return !selectable;
    };

    const handleRemoveTag = (claId: string) => {
        // 1) classList에서 해당 claId인 반 찾아서 학생들 체크 해제
        const seqNum = Number(claId);
        setClassMemberList((prev) =>
            prev.map((classItem) =>
                classItem.classInfo.classSeq === seqNum
                    ? {
                          ...classItem,
                          checkStudent: classItem.checkStudents.map((s) => ({
                              ...s,
                              checked: false,
                          })),
                      }
                    : classItem
            )
        );

        // 2) 태그 목록에서 제거
        setTags((prev) => prev.filter((tag) => tag.claId !== claId));
    };

    const onCreateClass = () => {
        showModal({
            isCustom: true,
            id: 'viva-create-class',
            initContents: () => (
                <VivaModalForm
                    onOk={() => {
                        onClose();
                        window.open(`${import.meta.env.VITE_VIVACLASS_DOMAIN}/main`, '_blank');
                    }}
                    classId="noneadminViva"
                    btnClass="btnApply"
                    popupId="viva-create-class"
                    title={
                        <p className="tit">
                            우리반 <strong>비바클래스</strong>를 만드세요.
                        </p>
                    }
                    description={
                        <>
                            <strong>
                                우리반 비바클래스를 만들고,
                                <br />
                                비바샘에서 제공하는 자료들을
                                <br />
                                학생들에게 공유하세요.
                            </strong>
                        </>
                    }
                    btnText="지금 바로 만들기"
                />
            ),
        });
    };

    return (
        <div className="set-file-box cont-mt step2">
            <div className="set-file-header">
                <div className="set-file-title">
                    <h3 className="title step_tab_title">STEP 2</h3>
                </div>
            </div>
            <div className="set-file-content content-type1">
                {/* 발행 방법 */}
                {/* 클래스/학생 선택 */}
                {/* NOTE: 분기 처리 필요 (개설한 비바클래스가 없을때, 학생을 선택 안했을 때) */}
                <div className="form-row baseline on">
                    <div className="form-label size-type1 title_wrap">
                        <div className="option_title">클래스 선택</div>
                    </div>
                    <div className="form-td">
                        <div className="cont_wrap">
                            {sMyClassMemberList?.length ? (
                                <>
                                    <div
                                        className="cont_wrap_inner class_select"
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '1rem',
                                        }}
                                    >
                                        <div className="dropdown-wrap">
                                            <div className="dropdown-box">
                                                <div
                                                    className={`dropdown-btn ${selectClassOpen && 'isOpen'}`}
                                                >
                                                    <button
                                                        type="button"
                                                        onClick={setSelectClassOpen}
                                                    >
                                                        {selectClass
                                                            ? selectClass.classInfo.clsName
                                                            : '클래스를 선택해 주세요.'}
                                                    </button>
                                                </div>
                                                <div
                                                    className={`dropdown-content ${selectClassOpen && 'isOpen'}`}
                                                >
                                                    <div className="option-type-default">
                                                        {classMemberList &&
                                                            !isLoading &&
                                                            [
                                                                {
                                                                    classInfo: {
                                                                        classSeq: -999,
                                                                        clsName: '전체 클래스 선택',
                                                                        clsTypeCode: '',
                                                                        schCourse: '',
                                                                        schTypeCode: '',
                                                                        schYear: '',
                                                                        schSubject: '',
                                                                    },
                                                                },
                                                                ...classMemberList,
                                                            ].map((item, idx) => {
                                                                const disabled = disabledClass(
                                                                    item.classInfo.clsTypeCode,
                                                                    item.classInfo.schSubject,
                                                                    item.classInfo.schCourse,
                                                                    item.classInfo.schTypeCode,
                                                                    item.classInfo.schYear
                                                                );
                                                                return (
                                                                    <div
                                                                        key={`publish-option-class-${idx}`}
                                                                        className={`option ${selectClass?.classInfo.classSeq === item.classInfo.classSeq && 'isCurrent'}`}
                                                                    >
                                                                        <button
                                                                            style={
                                                                                disabled
                                                                                    ? {
                                                                                          pointerEvents:
                                                                                              'none',
                                                                                          opacity: 0.5,
                                                                                      }
                                                                                    : undefined
                                                                            }
                                                                            type="button"
                                                                            onClick={() => {
                                                                                setSelectClassOpen();
                                                                                setSelectClass(
                                                                                    item
                                                                                );
                                                                                handleClassSelectAll(
                                                                                    item.classInfo
                                                                                        .classSeq,
                                                                                    true
                                                                                );
                                                                                if (
                                                                                    propsFilterStntList(
                                                                                        item
                                                                                            .classInfo
                                                                                            .classSeq
                                                                                    )?.length !== 0
                                                                                ) {
                                                                                    setTrigger(
                                                                                        (prev) =>
                                                                                            prev + 1
                                                                                    );
                                                                                }
                                                                            }}
                                                                        >
                                                                            {item.classInfo.clsName}
                                                                        </button>
                                                                    </div>
                                                                );
                                                            })}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="info_wrap">
                                            <p className="txt-ex info2">
                                                선택한 자료와 같은 과목의 클래스에만 발행할 수
                                                있습니다.
                                            </p>
                                        </div>
                                    </div>
                                    {selectClass && filterStntList()?.length === 0 && (
                                        <div className="cont_wrap_inner user_none_info">
                                            <div className="info_wrap">
                                                <p className="inner-txt info3">
                                                    클래스에 학생이 없습니다.
                                                    <br />
                                                    학생을 지정하지 않고 발행할 수 있습니다.
                                                </p>
                                                <p className="txt-ex info2 cont-mt">
                                                    발행 후, 발행함 메뉴의 발행 상세보기에서 학생을
                                                    추가 할 수 있습니다.
                                                </p>
                                                <button
                                                    type="button"
                                                    className="btn btn-default line_blue comfirm"
                                                    onClick={handleComplete}
                                                >
                                                    확인
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                    {/* {selectClass &&
                                        (filterStntList()?.length === 0 ? (
                                            <div className="cont_wrap_inner user_none_info">
                                                <div className="info_wrap">
                                                    <p className="inner-txt info3">
                                                        클래스에 학생이 없습니다.
                                                        <br />
                                                        학생을 지정하지 않고 발행할 수 있습니다.
                                                    </p>
                                                    <p className="txt-ex info2 cont-mt">
                                                        발행 후, 발행함 메뉴의 발행 상세보기에서
                                                        학생을 추가 할 수 있습니다.
                                                    </p>
                                                    <button
                                                        type="button"
                                                        className="btn btn-default line_blue comfirm"
                                                        onClick={handleComplete}
                                                    >
                                                        확인
                                                    </button>
                                                </div>
                                            </div>
                                        ) : (
                                            selectClass &&
                                            selectClass?.classInfo.classSeq !== -999 && (
                                                <div className="cont_wrap_inner user_select">
                                                    <div className="set-file-box">
                                                        <div className="set-file-header flex_b bg_white">
                                                            <p>학생 선택</p>
                                                            <button
                                                                type="button"
                                                                className="btn btn-default line_blue"
                                                                onClick={handleComplete}
                                                            >
                                                                완료
                                                            </button>
                                                        </div>
                                                        <div className="step_info_wrap">
                                                            <div className="chkList">
                                                                <span className="chk block chk_all">
                                                                    <input
                                                                        type="checkbox"
                                                                        id="chk_all"
                                                                        name="chk_all"
                                                                        value="chk_all"
                                                                        checked={isClassAllSelected}
                                                                        onChange={(e) =>
                                                                            handleClassSelectAll(
                                                                                selectClass
                                                                                    ?.classInfo
                                                                                    .classSeq,
                                                                                e.target.checked
                                                                            )
                                                                        }
                                                                    />
                                                                    <label htmlFor="chk_all">
                                                                        전체 선택
                                                                    </label>
                                                                </span>
                                                                <div className="flex_s chk_user cont-mt">
                                                                    {filterStntList()?.map(
                                                                        (stnt, i) => (
                                                                            <span
                                                                                className="chk"
                                                                                key={`select-student-${i}`}
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    id={`chk${i + 1}`}
                                                                                    name="chk"
                                                                                    value={
                                                                                        stnt.orgMemberId
                                                                                    }
                                                                                    checked={isClassSelected(
                                                                                        stnt.orgMemberId
                                                                                    )}
                                                                                    onChange={(e) =>
                                                                                        handleIndividualSelect(
                                                                                            stnt.classSeq,
                                                                                            stnt.orgMemberId,
                                                                                            e.target
                                                                                                .checked
                                                                                        )
                                                                                    }
                                                                                />
                                                                                <label
                                                                                    htmlFor={`chk${i + 1}`}
                                                                                >
                                                                                    {i +
                                                                                        1 +
                                                                                        '번 ' +
                                                                                        stnt.name}
                                                                                </label>
                                                                            </span>
                                                                        )
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        ))} */}
                                    {tags.length > 0 && (
                                        <div className="cont_wrap_inner search-form tag_wrap">
                                            <div className="tag-box">
                                                {tags.map((e, i) => (
                                                    <div key={`tag-item-${i}`} className="tag-item">
                                                        <span className="tag-txt">
                                                            {e.claNm}
                                                            {/* {' '}
                                                            <span>{e.stdtUserInfo?.length}명</span> */}
                                                        </span>
                                                        <button
                                                            onClick={() => handleRemoveTag(e.claId)}
                                                            type="button"
                                                            className="del-btn"
                                                        ></button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div className="cont_wrap_inner user_select">
                                    <div className="flex_b new_class_no class">
                                        <p>개설한 비바클래스가 없습니다.</p>
                                        <button
                                            type="button"
                                            className="btn btn-default icon blue2 arrow_right_w new_class_btn"
                                            onClick={() => onCreateClass()}
                                        >
                                            클래스 개설하기<i></i>
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
